// extracted by mini-css-extract-plugin
module.exports = {"taxReceiptHint":"TaxReceiptHint_taxReceiptHint__Bydwh","content":"TaxReceiptHint_content__DCf9O"};